import { Redirect, Route } from "react-router-dom";

import React from "react";

// Check if the localStorage has an access item. Can check further down if the access token is correct.

export const PrivateRoute = ({
  isAuthenticated,
  component: Component,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/"
          }}
        />
      )
    }
  />
);
